module.exports = "<ngx-loading-bar color=\"#7800E0\"></ngx-loading-bar>\n<router-outlet></router-outlet>\n\n"